import headerImage from "assets/onb-form-header-img.jpeg";
import "./index.scss";

export const OnboardingFormsHeader = () => {
  return (
    <div className="onboarding-form-header-wrapper">
      <img src={headerImage} alt="header-logo" className="header-img-style" />
    </div>
  );
};
